import {BaseProps} from "../../../infrastructure/models/props/base-props";

import React from 'react';

export class TableRowProps extends BaseProps {
  className: String;
}

export const TableRow = ({style, className, children}: TableRowProps) => {
  return (
    <tr className={className} style={style}>
      {children}
    </tr>
  )
}
